import { ApiModel } from '@/api/api-model';
import { Consorcio } from '../../../models/Consorcio';

export class DatosConsorcioPendientes extends ApiModel {

  meta: {
    nuevos_consorcios: number,
    propuestas_libres: number,
  }

  consorcios: Consorcio[]

  constructor(data?: any){
    super(data);
    this.consorcios = []; // Es necesario inicializar el arreglo
  }

  get nuevosConsorcios(): number {
    return this.meta.nuevos_consorcios;
  }

  get acuerdosLibres(): number {
    return this.meta.propuestas_libres;
  }
}

